import {
  NOTIFICATION,
  NOTIFICATION_ITEM,
  SNACKBAR,
} from "./../mutations-types";
import Vue from "vue";

const defaultOptions = {
  status: false,
  timeout: 6000,
  multiLine: false,
  left: false,
  bottom: false,
  right: true,
  top: true,
  vertical: false,
  centered: false,
  color: "rgba(0, 0, 0, 1)",
  absolute: false,
  message: "",
  transition: true,
};

export default {
  namespaced: true,
  state: {
    notification: defaultOptions,
    snackbar: null,
  },
  getters: {
    notification: (state) => {
      return state.notification;
    },
    snackbar: (state) => {
      return state.snackbar;
    },
  },
  mutations: {
    [SNACKBAR](state, snackbar) {
      state.snackbar = snackbar;
    },
    [NOTIFICATION](state, notification) {
      state.notification = notification;
    },
    [NOTIFICATION_ITEM](state, data) {
      state.notification[data.item] = data.value;
    },
  },
  actions: {
    notify: (store, options) => {
      // clear old snackbar
      clearTimeout(store.getters.snackbar);

      // merge default notifications options with current options and set notification
      let currentOptions = Object.assign(
        {},
        defaultOptions,
        { status: true },
        options
      );
      store.commit(NOTIFICATION, currentOptions);

      // set snackbar
      let snackbar = window.setTimeout(function() {
        store.commit(NOTIFICATION_ITEM, { item: "status", value: false });
        store.commit(NOTIFICATION, defaultOptions);
      }, currentOptions.timeout);

      store.commit(SNACKBAR, snackbar);
    },
    close: (store) => {
      let options = Object.assign({}, defaultOptions);
      store.commit(NOTIFICATION_ITEM, { item: "status", value: false });
      setTimeout(function() {
        store.commit(NOTIFICATION, options);
      }, 100);
    },
    async request(store, params) {
      return Vue.axios({
        ...params,
      });
    },
  },
};
